<template>
  <div>
    <Header class="yh-header" active="/ovop" :productValue="'5'"/>
    <div style="height: 70px"></div>
    <el-container class="container">
      <el-footer height="1100px">
        <div class="block-panel">
          <OvopExploreChinaDashboard :explore="explore" @change="onDataSourceChange" />
        </div>

        <div class="map-and-ranking">
          <OvopMap ref="map" />
        </div>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import Header from "@/components/Header";
import ProductCategoryHorizontalSelect from "@/components/ProductCategoryHorizontalSelect.vue";
import OneVillageOneProductPage from "@/components/OneVillageOneProductPage.vue";
import OvopMap from "@/components/OvopMap.vue";
import OvopRanking from "@/components/OvopRanking.vue";
import OvopExploreChinaDashboard from "@/components/OvopExploreChinaDashboard.vue";
import OvopExploreProvinceDashboard from "@/components/OvopExploreProvinceDashboard.vue";

export default {
  name: "ProductHome",
  components: {
    Header,
    ProductCategoryHorizontalSelect,
    OneVillageOneProductPage,
    OvopMap,
    OvopRanking,
    OvopExploreChinaDashboard,
    OvopExploreProvinceDashboard
  },
  data() {
    return {
      title: "全国",
      categoryCode: ""
    };
  },
  computed: {
    explore() {
      return this.$store.state.ovop.oneVillageOneProduct.explore;
    },
    provinceExplore() {
      return this.$store.state.ovop.oneVillageOneProduct.provinceExplore;
    },
    ovopArray() {
      return this.$store.state.ovop.oneVillageOneProduct.retrieve.results;
    }
  },
  created() {
    if (this.$route.query.categoryCode) {
      this.categoryCode = this.$route.query.categoryCode;
    }

    this.$store.dispatch("oneVillageOneProductPage", {
      packageName: "ovop",
      className: "oneVillageOneProduct",
      methodName: "explore",
      params: {}
    });

    this.$store.dispatch("productCategoryPage", {
      packageName: "product",
      className: "productCategory",
      methodName: "retrieve",
      params: {
        numPerPage: 1000
      }
    });

    this.$store.dispatch("oneVillageOneProductPage", {
      packageName: "ovop",
      className: "oneVillageOneProduct",
      methodName: "retrieve",
      params: {
        numPerPage: 10
      }
    });

    this.ajax.doPost({
      packageName: "user",
      className: "userAnalysis",
      methodName: "create",
      params: {
        userId: this.$store.state.sys.sysUser.me.id,
        moduleName: "一村一品-首页",
        moduleResourceId: this.$route.params.id,
        path: this.$route.path
      }
    });
  },
  methods: {
    onDataSourceChange(e) {
      this.$refs["map"].selectDataSource(e);
    },
    onCategoryCode(e) {
      this.$router.push(`/ovop/list?categoryCode=${e}`);
    },
    onSelected(e) {
      this.$store.dispatch("oneVillageOneProductPage", {
        packageName: "ovop",
        className: "oneVillageOneProduct",
        methodName: "retrieve",
        params: {
          numPerPage: 10,

          placeProvince: e.province,
          placeCity: e.city
        }
      });

      this.$store.dispatch("oneVillageOneProductPage", {
        packageName: "ovop",
        className: "oneVillageOneProduct",
        methodName: "provinceExplore",
        params: {
          placeProvince: e.province,
          placeCity: e.city
        }
      });

      if (e.province) {
        this.$store.dispatch("oneVillageOneProductPage", {
          packageName: "ovop",
          className: "oneVillageOneProduct",
          methodName: "provinceExplore",
          params: {
            placeProvince: e.province
          }
        });
      }

      this.title = e.province || e.city || "全国";
    }
  }
};
</script>

<style lang="less" scoped>
.el-header {
  box-shadow: 0px 0px 18px 0px rgba(0, 0, 0, 0.06);
}

.el-main {
  width: 1140px;
  margin: 20px auto;
}

.el-footer {
  background: #f7faf8;
  .block-panel {
    width: 1100px;
    margin: 0 auto;
    background: white;
    margin-top: 20px;
  }

  .map-and-ranking {
    width: 1100px;
    margin: 0 auto;
    background: white;
    margin-top: 20px;
  }
}
</style>
